import * as React from "react";
import * as LabelPrimitive from "@radix-ui/react-label";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";

const labelVariants = cva(
  "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
);

const Label = React.forwardRef<
  React.ElementRef<typeof LabelPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root> &
    VariantProps<typeof labelVariants> & { required?: boolean }
>(({ className, required, children, ...props }, ref) => (
  <LabelPrimitive.Root
    ref={ref}
    className={cn(
      labelVariants(),
      // MUDANÇA: text-foreground garante que a label seja branca/clara no dark mode
      "text-foreground",
      className,
    )}
    {...props}
  >
    {children}
    {required && (
      // MUDANÇA: O asterisco agora fica DENTRO da label (melhor UX/Click area)
      // text-destructive usa a cor de erro do seu tema (vermelho suave)
      <span className="ml-1 font-bold text-destructive">*</span>
    )}
  </LabelPrimitive.Root>
));
Label.displayName = LabelPrimitive.Root.displayName;

export { Label };
